import { getSystemConfig } from './config'

export function getLocaleDomain(lang, supply) {
  const systemConfig = getSystemConfig()
  let domain
  systemConfig.locale.locales.forEach((locale) => {
    if (locale.lang === lang && locale.supply === supply) {
      domain = locale.domain
    }
  })
  return domain
}

export function getDomainToLocale(domain) {
  const systemConfig = getSystemConfig()
  let toLocale = systemConfig.locale.defaultLocale
  if (domain) {
    systemConfig.locale.locales.forEach((locale) => {
      if (locale.domain === domain) {
        toLocale = locale.lang
      }
    })
  }
  return toLocale
}
